<template>
    <div>
        <el-row>
             <el-form>
                 <el-col :span="12">
                     <el-form-item label="公告内容：" label-width="120px">
                          <el-input type="textarea" v-model="content"></el-input>
                     </el-form-item>
                 </el-col>
                 <el-col :span="12">
                      <el-button type="primary" class="ml20" @click="submitNotice">修改</el-button>
                 </el-col>
             </el-form>
        </el-row>
    </div>
</template>

<script>
export default {
    data(){
      return {
         content:'' ,
      }  
    },
    created(){
       this.getNotice()
    },
    methods:{
        submitNotice(){
            const data = {}
            data.content = this.content
            this.$http.post('/noticeManage/updateNotice',data).then(res => {
              if(res.data.code == 200) {
                    this.$notify.success({
                        title: '提示',
                        message: '修改成功',
                        showClose: true
                    })
                    this.etNotice()
               }
            })
        },
        getNotice(){
           const data = {}
           this.$http.post('/noticeManage/queryNotice',data).then(res => {
             if(res.data.code == 200) {
                 this.content = res.data.data.content
              }
           })
        },
    }

}
</script>

<style scoped>
  
</style>